import type { NavigationGuard } from "vue-router";

import { useBackUrl } from "@/composables";

export function orderIdParameterGuard(): NavigationGuard {
  return (to) => {
    const backUrl = useBackUrl(to);

    if (!to.query.orderId) {
      return { path: backUrl.value };
    }

    const orderId = parseInt(to.query.orderId as string);
    if (isNaN(orderId)) {
      return { path: backUrl.value };
    }
  };
}
